import React, { lazy, Suspense, useEffect, useState } from "react";
import { createPortal } from "react-dom";
import { useLocation, useNavigate } from "react-router-dom";
import { Loader2, Play, X } from "lucide-react";

const CommercialPlayer = lazy(() => import("./CommercialPlayer"));

/** "Watch the commercial": opens the 2-minute commercial full-screen (like Watch the Platform), closes itself when it ends. #commercial opens it too. */
export function CommercialCta({ className, style, source = "hero" }) {
  const [open, setOpen] = useState(false);
  const { hash, pathname, search } = useLocation();
  const navigate = useNavigate();
  const start = () => { document.documentElement.requestFullscreen?.().catch(() => {}); setOpen(true); };
  const exit = () => {
    setOpen(false);
    if (document.fullscreenElement) document.exitFullscreen().catch(() => {});
    if (window.location.hash === "#commercial") navigate(pathname + search, { replace: true });
  };
  useEffect(() => { if (hash === "#commercial") setOpen(true); }, [hash]);
  useEffect(() => {
    if (!open) return undefined;
    const key = (e) => { if (e.key === "Escape") exit(); };
    const fs = () => { if (!document.fullscreenElement) exit(); };
    window.addEventListener("keydown", key);
    document.addEventListener("fullscreenchange", fs);
    document.body.style.overflow = "hidden";
    return () => { window.removeEventListener("keydown", key); document.removeEventListener("fullscreenchange", fs); document.body.style.overflow = ""; };
  }, [open]); // eslint-disable-line react-hooks/exhaustive-deps
  return (
    <>
      <button type="button" onClick={start} data-testid={`${source}-commercial-cta`} className={className} style={style}>
        <Play className="h-4 w-4 fill-current" /> The Mission
      </button>
      {open && createPortal(
        <div className="fixed inset-0 z-[9999] bg-black flex items-center justify-center" data-testid={`${source}-commercial-fullscreen`}>
          <div className="w-[min(100vw,177.78vh)]">
            <Suspense fallback={<div className="grid place-items-center aspect-video text-[#D4AF37]"><Loader2 className="h-8 w-8 animate-spin" /></div>}>
              <CommercialPlayer autoPlay onEnded={exit} />
            </Suspense>
          </div>
          <button type="button" onClick={exit} aria-label="Close the commercial" data-testid="commercial-close-btn"
            className="absolute top-4 right-4 w-10 h-10 rounded-full bg-white/10 hover:bg-white/20 text-white flex items-center justify-center transition-colors"><X className="h-5 w-5" /></button>
        </div>, document.body)}
    </>
  );
}
